import { defineComponent as _defineComponent } from 'vue'

import { computed, onMounted } from 'vue';
import { setCookie } from '@/utils/cookies';
import * as crypto from 'crypto-js';

const __default__ = { name: 'RegisterHandler' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  referral: {
    type: [String, null],
    default: null,
  },
  id_login: {
    type: [Number, null],
    default: null,
  },
},
  setup(__props) {


const hashLink = computed(() => {
  const now = new Date();
  const date_str = (`0${now.getDate()}`).slice(-2) + (`0${now.getMonth() + 1}`).slice(-2) + now.getFullYear();
  const hash = crypto.SHA1(`dev.ecohospital.ru${date_str}`);
  const digestHex = hash.toString(crypto.enc.Hex);
  return digestHex;
});

const props = __props;

if (props.referral) {
  console.log('Реферал:', props.referral);
  setCookie('dev-eco-guid', props.referral, { secure: true, expires: 1 });
  setCookie('id_sponsor', `${props.id_login}`, { secure: true, expires: 1 });
}

onMounted(() => {
  window.open(
    `https://esia.medsafe.tech/${hashLink.value}`,
    '_self',
  );
  setCookie('dev-eco-hash', hashLink.value, { secure: true, expires: 1 });
});

return () => {}
}

})